(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbv-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cbv-home-builder')) {
  customElements.define('cbv-home-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      // Defer until the element's children have been parsed.
      setTimeout(() => this.initialize(), 0);
    }
    async initialize() {
      this.$ = (selector) => this.querySelector(selector);
      this.variant = this.$('[data-variant]');
      this.family = this.$('[data-family]');
      this.search = this.$('[data-search]');
      this.fragrance = this.$('[data-fragrance]');
      this.button = this.$('[data-add]');
      this.status = this.$('[data-status]');
      this.busy = false;
      this.ready = false;
      this.$('form').addEventListener('submit', (event) => this.addToCart(event));
      try {
        this.products = JSON.parse(this.$('[data-products]').textContent);
        let page = JSON.parse(this.$('[data-scents]').textContent);
        let rows = page.items;
        const visited = new Set();
        // Load every fragrance page, rather than silently truncating the library.
        while (page.next) {
          const url = new URL(page.next, location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid fragrance pagination');
          visited.add(url.href);
          const response = await fetch(url.href);
          if (!response.ok) throw new Error('Fragrance request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const island = doc.getElementById(this.id)?.querySelector('[data-scents]');
          if (!island) throw new Error('Fragrance page missing');
          page = JSON.parse(island.textContent);
          rows = rows.concat(page.items);
        }
        this.scents = this.cleanScents(rows);
        if (!this.products.length) throw new Error('No products configured');
        if (!this.scents.length) throw new Error('No published fragrances');
        this.ready = true;
        this.chooseProduct();
        this.status.textContent = 'Choose a fragrance category, or search all fragrances by name.';
        this.variant.addEventListener('change', () => this.update());
        this.family?.addEventListener('change', () => { this.search.value = ''; this.filterScents(); });
        this.search.addEventListener('input', () => this.filterScents());
        this.fragrance.addEventListener('change', () => {
          if (!this.family.value && this.fragrance.value) {
            const scent = this.availableScents.find(s => s.name === this.fragrance.value);
            if (scent) this.family.value = scent.families[0];
          }
          this.update();
        });
      } catch (error) {
        console.error('Home builder:', error);
        this.status.textContent = 'Product or fragrance choices are unavailable right now. Please contact us for help.';
        this.options(this.family, 'Choices unavailable', []);
      }
    }
    cleanScents(rows) {
      const unique = new Map();
      for (const row of rows) {
        if (typeof row?.name !== 'string' || !row.name.trim()) continue;
        const name = row.name.trim();
        const raw = Array.isArray(row.family) ? row.family : [row.family];
        const families = raw.filter(v => typeof v === 'string' && v.trim()).map(v => v.trim());
        const existing = unique.get(name.toLowerCase());
        const values = families.length ? families : ['Other'];
        if (existing) existing.families = [...new Set(existing.families.concat(values))];
        else unique.set(name.toLowerCase(), {name, families: values});
      }
      return [...unique.values()].sort((a,b) => a.name.localeCompare(b.name));
    }
    options(select, placeholder, values) {
      select.replaceChildren(new Option(placeholder, ''));
      for (const [value, label] of values) select.add(new Option(label, value));
    }
    chooseProduct() {
      this.product = this.products[0];
      const product = this.product;
      this.search.value = '';
      this.search.disabled = !product;
      this.$('[data-cart]').hidden = true;
      this.status.textContent = '';
      const photo = this.$('[data-photo]');
      photo.hidden = !product?.image;
      if (product?.image) { photo.src = product.image; photo.alt = product.title; }
      else photo.removeAttribute('src');
      this.$('[data-photo-placeholder]').hidden = !!product?.image;
      this.$('[data-photo-placeholder]').textContent = product ? product.title : 'Loading product…';
      const variants = product?.variants || [];
      this.options(this.variant, 'Choose an option', variants.map(v => [v.id, v.title + (v.available ? '' : ' — Sold out')]));
      for (const option of this.variant.options) {
        if (option.value) option.disabled = !variants.find(v => v.id === option.value)?.available;
      }
      this.variant.value = variants.find(v => v.available)?.id || '';
      this.variant.disabled = !product;
      this.$('[data-variant-field]').hidden = variants.length <= 1;
      const allowedInput = Array.isArray(product?.allowed) ? product.allowed : (product?.allowed || '').split(/\r?\n/);
      const allowed = new Set(allowedInput.map(s => String(s).trim().toLowerCase()).filter(Boolean));
      this.availableScents = product ? this.scents.filter(s => !allowed.size || allowed.has(s.name.toLowerCase())) : [];
      if (this.family) {
        const families = [...new Set(this.availableScents.flatMap(s => s.families))].sort((a,b) => a.localeCompare(b));
        this.options(this.family, 'Choose a fragrance category', families.map(f => [f,f]));
        this.family.disabled = !product;
      }
      this.filterScents();
    }
    filterScents() {
      const selected = this.fragrance.value;
      const query = this.search.value.trim().toLowerCase();
      const family = this.family?.value;
      const matches = !family && !query ? [] : (this.availableScents || []).filter(s => (!family || s.families.includes(family)) && (!query || s.name.toLowerCase().includes(query)));
      this.options(this.fragrance, !family && !query ? 'Choose a category or search above' : matches.length ? 'Choose a fragrance' : 'No matching fragrances', matches.map(s => [s.name,s.name]));
      if (matches.some(s => s.name === selected)) this.fragrance.value = selected;
      this.fragrance.disabled = !this.product || !matches.length;
      this.$('[data-results]').textContent = !family && !query ? 'Choose a category, or search all fragrances by name.' : matches.length ? `${matches.length} fragrances available` : 'No matches. Try another search or fragrance family.';
      this.update();
    }
    update() {
      const variant = this.product?.variants.find(v => v.id === this.variant.value);
      const valid = this.ready && variant?.available && !this.product.subscriptionOnly && !this.fragrance.disabled && !!this.fragrance.value && !!this.family.value;
      this.$('[data-price]').textContent = variant?.price || '';
      this.button.disabled = this.busy || !valid;
      this.button.textContent = this.busy ? 'Adding…' : this.product?.subscriptionOnly ? 'Subscription options unavailable here' : this.product && !variant?.available ? 'Unavailable' : valid ? 'Add to cart' : 'Choose your fragrance';
    }
    async addToCart(event) {
      event.preventDefault();
      this.update();
      if (this.button.disabled || this.busy) return;
      const item = {id:this.variant.value, quantity:1, properties:{Fragrance:this.fragrance.value, 'Fragrance Category':this.family.value}};
      this.busy = true;
      this.update();
      // Freeze choices during submission so order details cannot change mid-request.
      const controls = [...this.querySelectorAll('select,input')];
      const disabledStates = controls.map(c => c.disabled);
      controls.forEach(c => { c.disabled = true; });
      this.status.textContent = '';
      this.$('[data-cart]').hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[item]})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
        // Go to the real cart so the theme's cart count and contents refresh together.
        this.status.textContent = 'Added to your cart.';
        this.$('[data-cart]').hidden = false;
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        controls.forEach((c,i) => { c.disabled = disabledStates[i]; });
        this.busy = false;
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const init = () => {
      // 1. Mobile Drawer
      const body = document.body;
      const drawer = document.querySelector('[data-cbv-mobile-drawer]');
      const overlay = document.querySelector('[data-cbv-mobile-overlay]');
      const toggles = document.querySelectorAll('[data-cbv-toggle-drawer]');
      const accordionButtons = document.querySelectorAll('[data-cbv-accordion]');

      if (drawer && overlay) {
        const toggleDrawer = () => {
          const open = drawer.classList.toggle('is-open');
          overlay.classList.toggle('is-active', open);
          body.style.overflow = open ? 'hidden' : '';
        };

        toggles.forEach((button) => {
          button.addEventListener('click', toggleDrawer);
        });

        overlay.addEventListener('click', toggleDrawer);

        accordionButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const menuItem = button.closest('.cbv-mobile-item');
            if (!menuItem) return;
            menuItem.classList.toggle('is-expanded');
          });
        });
      }

      // 2. Fixed Header Morph & dynamic page padding Logic
      const fixedGroup = document.querySelector('.cbv-header-fixed-group');
      if (!fixedGroup) return;

      // Replaces manual offset setup with robust ResizeObserver 
      const headerObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (!fixedGroup.classList.contains('is-scrolled')) {
            document.documentElement.style.setProperty('--cbv-header-offset', `${entry.target.offsetHeight}px`);
          }
        }
      });
      headerObserver.observe(fixedGroup);

      // Scroll Handler
      let ticking = false;
      const SCROLL_THRESHOLD = 50;

      const onScroll = () => {
        const currentScroll = window.scrollY;
        
        if (currentScroll > SCROLL_THRESHOLD) {
          fixedGroup.classList.add('is-scrolled');
        } else {
          fixedGroup.classList.remove('is-scrolled');
        }
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            onScroll();
            ticking = false;
          });
          ticking = true;
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
